import React from 'react';
import Icon from './Icon';

export default function Seg({ label, active, onClick, icon }) {
  return (
    <button onClick={onClick} className={`seg ${active ? 'segOn' : ''}`} aria-pressed={active}>
      <span className="segI"><Icon name={icon} /></span>
      <span className="segT">{label}</span>
    </button>
  );
}
